<template>
    <div class="d-flex flex-column min-vh-100">
        <header class="sticky-top bg-light">
            <div class="container">
                <TopNavbar @languageChanged="updateLanguage" :key="language" />
                <MainNavbar @menuChanged="updateNavbarId" :key="language" />
            </div>
        </header>

        <main class="flex-grow-1 mb-5">
            <HeadMain :key="`${language}-${navbarId}`" />
            <ContentComponent
                v-if="currentType === 'content'"
                :key="`${language}-${navbarId}-${eventId || ''}`"
                :eventId="eventId"
                @showNews="handleShowNews"
            />
            <CardComponent
                v-if="currentType === 'news'"
                :key="`${language}-${navbarId}`"
                @showEventDetail="handleEventDetail"
            />
            <FotoGalleryComponent
                v-if="currentType === 'foto_gallery'"
                :key="`${language}-${navbarId}`"
            />
            <VideoGalleryComponent
                v-if="currentType === 'video_gallery'"
                :key="`${language}-${navbarId}`"
            />
        </main>

        <footer class="bd-footer mt-5 bg-body-tertiary bg-light">
            <CustomFooter :key="language" />
        </footer>
    </div>
</template>

<script>
import TopNavbar from '@/components/SiteComponents/Navbar/TopNavbar.vue'
import MainNavbar from '@/components/SiteComponents/Navbar/MainNavbar.vue'
import HeadMain from '@/components/SiteComponents/Main/HeadMain.vue'
import CustomFooter from '@/components/SiteComponents/Footer/CustomFooter.vue'
import ContentComponent from "@/components/SiteComponents/Main/Home/ContentComponent.vue";
import CardComponent from "@/components/SiteComponents/Main/Components/CardComponent.vue";
import FotoGalleryComponent from "@/components/SiteComponents/Main/Components/FotoGalleryComponent.vue";
import VideoGalleryComponent from "@/components/SiteComponents/Main/Components/VideoGalleryComponent.vue";

export default {
    name: 'SiteHome',
    components: {
        VideoGalleryComponent,
        FotoGalleryComponent,
        CardComponent,
        ContentComponent,
        TopNavbar,
        MainNavbar,
        HeadMain,
        CustomFooter,
    },
    data() {
        return {
            language: localStorage.getItem('language') || 'uz',
            navbarId: localStorage.getItem('navbar_item') || 1,
            currentType: localStorage.getItem('navbar-type') || 'content',
            eventId: localStorage.getItem('event_id') || null,
        }
    },
    methods: {
        updateLanguage(newLanguage) {
            this.language = newLanguage;
            localStorage.setItem('language', newLanguage);
        },
        updateNavbarId(data) {
            this.navbarId = data.navbarId;
            this.currentType = data.type;
            this.eventId = null;
            localStorage.setItem('navbar-type', this.currentType);
            localStorage.setItem('navbar_item', this.navbarId);
            localStorage.removeItem('event_id');
        },
        handleEventDetail(eventId) {
            this.currentType = 'content';
            this.eventId = eventId;
            localStorage.setItem('navbar-type', this.currentType);
            localStorage.setItem('event_id', eventId);
        },
        handleShowNews() {
            this.currentType = 'news'; // CardComponent'ni ko‘rsatish
            this.eventId = null; // eventId'ni tozalash (ixtiyoriy)
            localStorage.setItem('navbar-type', this.currentType);
            localStorage.removeItem('event_id'); // eventId'ni tozalash
        }
    },
}
</script>

<style></style>
